<!--
 * @Author: DXG
 * @Date: 2024-04-25 17:39:49
 * @LastEditors: situgen@szkingdom.com
 * @LastEditTime: 2025-07-09 20:19:26
 * @FilePath: \kdtup-pc-web\src\bizcomponents\fund\buyFund.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<!--
Author: TangChen
Date: 2018-12-8
Desc: 购买基金，由index.js 配置引入
-->
<template>
    <div>
        <div :class="'bizcomp-buy-fund bizcomp ' + className">
            <comp-title-dc :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/fund' }">基金交易</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title-dc>
            <!--购买逻辑全在该组件内-->
            <buy-comp ref="buyComp" v-on:fund-data="getFundData" />
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import buyComp from "@/components/fund/buyCompDC";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "BuyFund",
    components: {
        buyComp,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            commonQuestion: [], // 常见问题
            warningHtml: "", // 温馨提示
            warningHtml15: ""
        };
    },
    mounted() {
        setTimeout(() => {
            this.assignTipAndQuestion();
        }, 10);
    },
    methods: {
        // 赋值温馨提示和常见问题
        assignTipAndQuestion() {
            this.commonQuestion = this.$const.commonQuestion.commonQuestion15.map((item) => {
                if (item.title === "1.申购费率是多少？是否有优惠？") {
                    // 对 answer 进行处理
                    const formattedAnswer = item.answer
                        // 将电话号码更换
                        .replace(/(400-888-5558)/, this.$cache.getCompanyInfoParam("10101009"));

                    // 返回新对象，保留其他属性
                    return { ...item, answer: formattedAnswer };
                }
                return item; // 其他条目保持不变
            });
            this.warningHtml15 = warningHtml.warningHtml15;
        },
        getFundData(data) {
            let cyclerate = "";
            if (data.cycleratetype && data.cycleratevalue) {
                cyclerate = `<p style="color: red">3.买入并确认份额后锁定${
                    data.cycleratevalue
                }${this.$cache.getDict(
                    "220027",
                    data.cycleratetype
                )}，期间不可卖出，请做好资金安排</p>`;
            }
            const addWarningHtml = this.warningHtml15 + cyclerate;
            this.warningHtml = addWarningHtml;
        }
    }
};
</script>
